import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getAccess, log } from 'utils';
import {
  bulkInformation,
  deleteInformation,
  fetchInformation,
} from 'state/actions/information';
// import { regexInput } from 'utils/regex';
// import Table from 'components/Table';
import _ from 'underscore';
import { EmptyIcon } from 'assets/icon/bigicon';
import { FilterIcon } from 'assets/icon';
import ModalInformationCategoryForm from 'components/ModalInformationCategoryForm';
import {
  createInformationCategory,
  deleteInformationCategory,
  fetchInformationCategories,
  modifyInformationCategory,
  setInformationCategory,
} from 'state/actions/informationCategories';
import ModalDelete from 'components/ModalDelete';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import './WebMenusPage.scss';
import './WebMenusPage.css';
import {
  setInfoCategory,
  setTabInformation,
} from '../../state/actions/breadcrumb';
import { fetchPois } from 'state/actions/pois';
import AddWebMenusForm from './AddWebMenusForm';
import { deleteWebMenu, fetchWebMenus } from 'state/actions/webMenus';

const WebMenusPage = ({ history }) => {
  const { siteId, siteName } = useParams();

  const {
    informationCategories,
    selectedCategory,
    loading,
    userData,
    role,
    updated,
    category,
    selectedTab,
    categoryLoading,
    webMenus,
  } = useSelector(
    (state) => ({
      selectedCategory: state.breadcrumb.infoCategory,
      informationCategories: state.informationCategories.list,
      error: state.information.error,
      loading: state.information.loading,
      deleted: state.information.deleted,
      userData: state.auth.userData,
      updated: state.information.updated,
      role: state.auth.userData.role,
      category: state.informationCategories.category,
      selectedTab: state.breadcrumb.information,
      categoryLoading: state.informationCategories.loading,
      informationData: state.information.information,
      webMenus: state.webMenus.list,
    }),
    shallowEqual
  );

  if (webMenus) {
    log(webMenus, '<<< webMenus list');
  }

  const [deleteModal, setDeleteModal] = useState({
    information: null,
    isOpen: false,
  });

  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  // const [isEditing, setIsEditing] = useState(false);
  // const [visible, setVisible] = useState(false);
  // const [searchError, setSearchError] = useState(null);
  const [tempSelectedCategory, setTempSelectedCategory] =
    useState(selectedCategory);
  const [playlistOpen, setPlaylistOpen] = useState(false);
  // const [minValue, setMinValue] = useState(0);
  // const [maxValue, setMaxValue] = useState(16);
  const [modalCategory, setModalCategory] = useState(false);
  const [dragDropElement, setDragDropElement] = useState({
    dragged: '',
    enter: '',
  });
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });

  const [access, setAccess] = useState(null);

  const uid = userData.id;

  useEffect(() => {
    if (userData?.roleAccess) {
      setAccess(getAccess(userData, 'menu', siteId));
    }
  }, [userData, siteId]);

  const onRemoveButtonClickHandler = (information) => {
    setDeleteModal({
      information,
      isOpen: true,
    });
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ information: null, isOpen: false });
  };

  const onDeleteInformationHandler = () => {
    dispatch(
      deleteWebMenu({ id: deleteModal.information, siteId }, () => {
        onCloseModalHandler();
      })
    );
  };

  // const onNewInformationHandler = () => {
  //   setInformation(defaultInformation);
  //   setIsEditing(false);
  //   setVisible(true);
  // };

  const handleSearch = (e) => {
    // setSearchError(null);
    // if (!regexInput(e.target.value) && e.target.value) {
    //   setSearchError('Search cannot using special character');
    // }
    console.log(e.target.value);
    setSearch(e.target.value);
  };

  const filteredData = search
    ? webMenus.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : webMenus;

  // const confirmMessage = useFormatMessage('Information.confirm');

  // const permDeleteMessage = useFormatMessage('Information.permDelete');

  const getCategory = (categoryId) => {
    const findCategory = informationCategories.find(
      (cat) => cat._id === categoryId
    );
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    dispatch(setInfoCategory(tempSelectedCategory));
    setPlaylistOpen(false);
  };

  const handleEdit = (menu) => {
    setEditingMenu(menu);
    setShowAddMenu(true);
  };

  const onSubmitCategory = () => {
    const action = category._id
      ? modifyInformationCategory
      : createInformationCategory;

    dispatch(
      action({ uid, ...category, siteId, id: category._id }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setInformationCategory(data));
  };

  const handleEditCategory = (category) => {
    // setIsEditing(true);
    dispatch(setInformationCategory(category));
    setModalCategory(true);
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteInformationCategory(modalDeleteCategory.category._id, () =>
        onCloseModalCategoryHandler()
      )
    );
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };

  const handleNew = () => {
    dispatch(
      setInformationCategory(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  useEffect(() => {
    dispatch(fetchWebMenus({ siteId }));
  }, []);

  const [showAddMenu, setShowAddMenu] = useState(false);
  const [editingMenu, setEditingMenu] = useState(null);

  return showAddMenu ? (
    <AddWebMenusForm
      menuData={editingMenu}
      onClose={() => {
        setShowAddMenu(false);
        setEditingMenu(null);
      }}
    />
  ) : (
    <div className="web-menu-library">
      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeleteInformationHandler}
        onCancel={onCloseModalHandler}
        title="Delete Menu"
        subtitle={deleteModal.information ? deleteModal.information.name : ''}
        loading={loading}
      />

      <div className="web-menu-header">
        <div className="web-menu-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                // value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className="actions__wrapper">
          {role !== 'superadmin' ? (
            access &&
            access.create && (
              <div onClick={() => setShowAddMenu(true)} className="btn-primary">
                <i className="feather-plus mr-2" />
                Add Menu
              </div>
            )
          ) : (
            <div onClick={() => setShowAddMenu(true)} className="btn-primary">
              <i className="feather-plus mr-2" />
              Add Menu
            </div>
          )}
        </div>
      </div>

      <div className="web-menu-content-wrapper">
        <div className="web-menu-content">
          <div
            className="web-menu-list-content"
            style={{
              marginLeft: '1rem',
            }}
          >
            {webMenus.length > 0 && filteredData.length > 0 ? (
              _.chunk(filteredData, 3).map((chunk, index) => {
                return (
                  <div className="web-menu-list-chunk" key={index}>
                    {chunk.map((menuData) => {
                      return (
                        <div
                          key={menuData._id}
                          data-id={menuData._id}
                          className={`web-menu-list ${
                            dragDropElement.dragged === menuData._id
                              ? 'dragged'
                              : ''
                          } ${
                            dragDropElement.enter === menuData._id
                              ? 'entered'
                              : ''
                          }`}
                          draggable
                          onDragStart={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: menuData._id,
                            })
                          }
                          onDragEnd={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: '',
                            })
                          }
                          onDragEnter={() => {
                            setDragDropElement({
                              ...dragDropElement,
                              enter: menuData._id,
                            });
                          }}
                          onDragOver={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onDrop={(e) => {}}
                        >
                          <Cards
                            data={menuData}
                            type="web-menu"
                            editAction={() => handleEdit(menuData)}
                            deleteAction={() =>
                              onRemoveButtonClickHandler(menuData._id)
                            }
                          />
                        </div>
                      );
                    })}
                    {chunk.length < 2 && (
                      <div className="web-menu-list-empty" />
                    )}
                    {chunk.length < 3 && (
                      <div className="web-menu-list-empty" />
                    )}
                  </div>
                );
              })
            ) : (
              <div className="web-menu-empty">
                <Empty image={<EmptyIcon />} description="No Menu" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebMenusPage;
